import React, { useEffect } from 'react'
import './easiwareForm.css'
import { useScript } from 'hooks/useScript.hooks'
import { useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { useIntl } from 'react-intl'
import { getEasiwareScript } from 'app/faq/utils'

type Props = {
    formId?: string,
    solutionId?: string,
    divId?: string,
    theme?: string
}

let easiform: any

const EasiwareForm = (props: Props) => {
    const { formId, solutionId, divId, theme } = props
    const intl = useIntl()
    const { email, firstname, lastname, civility, authenticated } = useSelector(
        (state: RootState) => ({
            email: state.kingdomProfilePageState.email,
            firstname: state.kingdomProfilePageState.firstname,
            lastname: state.kingdomProfilePageState.lastname,
            civility: state.kingdomProfilePageState.civility,
            authenticated: state.userState.authenticated
        })
    )

    const manKey = intl.formatMessage({ id: 'form.civility.man.key' })
    const womanKey = intl.formatMessage({ id: 'form.civility.woman.key' })
    const man = intl.formatMessage({ id: 'form.civility.man' })
    const woman = intl.formatMessage({ id: 'form.civility.woman' })

    const easiwareHtmlScript =
        formId && solutionId && getEasiwareScript(formId, solutionId)

    /*
     * Easiware tries to remove its scripts and form when the component unmount
     * However we appended the Easiware scripts and form to a specific element in our HTML
     * Easiware cannot find them so we have to change the default function of removing a child to avoid an error
     * */
    const fixRemoveChildError = () => {
        //$FlowFixMe
        if (typeof Node === 'function' && Node.prototype) {
            const originalRemoveChild = Node.prototype.removeChild
            //$FlowFixMe
            Node.prototype.removeChild = function(child) {
                if (child.parentNode !== this) {
                    return null
                }
                return originalRemoveChild.apply(this, arguments)
            }
        }
    }

    useScript({ innerText: easiwareHtmlScript }, divId)

    useEffect(() => {
        fixRemoveChildError()
        if (!!divId) {
            const easiware = document.getElementById(divId)
            const parent = easiware?.parentNode
            const easiwareForm = document.getElementById('easiformarea')
            const easiwareFormWaiting = document.getElementById(
                'easiformWaiting'
            )
            return () => {
                if (parent) {
                    easiwareForm && parent.removeChild(easiwareForm)
                    easiwareFormWaiting &&
                        parent.removeChild(easiwareFormWaiting)
                    easiware && parent.removeChild(easiware)
                }
            }
        }
    }, [theme])

    useEffect(() => {
        if (authenticated) {
            easiform = document.getElementById('easiform')
            if (!!easiform) {
                fillForm()
            }
        }
    }, [authenticated, easiform])

    const isSameGender = (form?: string) => {
        return (
            (form === manKey && civility === man) ||
            (form === womanKey && civility === woman)
        )
    }

    const fillForm = () => {
        //$FlowFixMe
        const formCivility = document.getElementById('fld_Salutation')
        //$FlowFixMe
        document.getElementById('fld_LastName').value = lastname
        //$FlowFixMe
        document.getElementById('fld_FirstName').value = firstname
        //$FlowFixMe
        document.getElementById('fld_Email').value = email

        //$FlowFixMe
        for (let i = 0; i < formCivility?.options?.length; i++) {
            //$FlowFixMe
            const option = formCivility?.options[i]
            if (isSameGender(option?.value)) {
                //$FlowFixMe
                formCivility.selectedIndex = i
            }
        }
    }

    return null
}

export { EasiwareForm }
